@if (gorunur) {
<div class="ko-modal-overlay" (click)="kapat()">
  <div class="ko-modal" (click)="$event.stopPropagation()">

    <!-- Modal Baslik -->
    <div class="ko-modal-baslik">
      <span>Kart Okuyucu Ayarlari</span>
      <button class="ko-modal-kapat" (click)="kapat()">✕</button>
    </div>

    <!-- Sekmeler -->
    <div class="ko-tab-basliklar">
      <button class="ko-tab-btn" [class.aktif]="aktifTab === 0" (click)="aktifTab = 0">
        🔌 Seri Port
        @if (seriDurum === 'bagli') { <span class="ko-tab-led yesil"></span> }
      </button>
      <button class="ko-tab-btn" [class.aktif]="aktifTab === 1" (click)="aktifTab = 1">
        🌐 Socket.IO
        @if (wsDurum === 'bagli') { <span class="ko-tab-led yesil"></span> }
      </button>
      <button class="ko-tab-btn" [class.aktif]="aktifTab === 2" (click)="aktifTab = 2">
        📟 Monitor
        @if (seriLog.length > 0) { <span class="ko-tab-sayac">{{ seriLog.length }}</span> }
      </button>
    </div>

    <!-- Sekme icerikleri -->
    <div class="ko-tab-icerik">

      <!-- ===== SERI PORT SEKMESI ===== -->
      @if (aktifTab === 0) {
      <div class="ko-tab-panel ko-fade-in">
        @if (!seriPortDestekleniyor) {
          <div class="ko-uyari">Bu tarayici Web Serial API desteklemiyor. Chrome/Edge kullanin.</div>
        } @else {

          @if (portListesi.length > 0) {
          <div class="ko-alan">
            <div class="ko-alan-etiket">Kayitli Portlar</div>
            <div class="ko-port-liste">
              @for (p of portListesi; track p.etiket) {
              <div class="ko-port-item" [class.secili]="seciliPort === p" (click)="seciliPort = p; portSecildi.emit(p)">
                <span class="ko-port-led" [class.bagli]="seriPortAktifPort === p.port && seriDurum === 'bagli'"></span>
                <span class="ko-port-ad">{{ p.etiket }}</span>
                @if (p.bilgi.usbVendorId) {
                  <span class="ko-port-vid">VID:{{ p.bilgi.usbVendorId?.toString(16).toUpperCase() }}</span>
                }
              </div>
              }
            </div>
          </div>
          }

          <button class="ko-btn ko-btn-outline" (click)="yeniPortIste.emit()">+ Yeni Port Ekle</button>

          <div class="ko-alan">
            <div class="ko-alan-etiket">Baud Rate</div>
            <div class="ko-baud-grup">
              @for (b of baudSecenekleri; track b) {
              <button class="ko-baud-btn" [class.secili]="seciliBaud === b" (click)="baudDegisti.emit(b)">{{ b }}</button>
              }
            </div>
          </div>

          <div class="ko-aksiyon-row">
            @if (seriDurum !== 'bagli') {
              <button class="ko-btn ko-btn-baglan" [disabled]="!seciliPort || seriDurum === 'baglaniyor'" (click)="seriBaglan.emit()">
                {{ seriDurum === 'baglaniyor' ? 'Baglaniyor...' : 'Baglan' }}
              </button>
            } @else {
              <button class="ko-btn ko-btn-kopar" (click)="seriKopar.emit()">Baglantiyi Kes</button>
            }
          </div>

          @if (seriHata) { <div class="ko-hata">{{ seriHata }}</div> }
        }
      </div>
      }

      <!-- ===== SOCKET.IO SEKMESI ===== -->
      @if (aktifTab === 1) {
      <div class="ko-tab-panel ko-fade-in">

        <div class="ko-alan">
          <div class="ko-alan-etiket">Durum</div>
          <div class="ko-ws-durum">
            <span class="ko-ws-led" [class.bagli]="wsDurum === 'bagli'"></span>
            @if (wsDurum === 'bagli') {
              Sunucu bagli - Kart olaylari dinleniyor
            } @else if (wsDurum === 'baglaniyor') {
              Baglaniyor...
            } @else {
              Dinleme kapalı
            }
          </div>
        </div>

        <div class="ko-alan">
          <div class="ko-alan-etiket">Cihaz Filtresi (opsiyonel)</div>
          <input class="ko-input" type="text" [(ngModel)]="wsCihazKimlik" placeholder="FikoYT-Kart-Okuyucu-1" />
          <div class="ko-alan-aciklama">Sadece bu cihazdan gelen olaylari dinle. Bos birakirsaniz tum cihazlar dinlenir.</div>
        </div>

        <div class="ko-aksiyon-row">
          @if (wsDurum !== 'bagli') {
            <button class="ko-btn ko-btn-baglan" [disabled]="wsDurum === 'baglaniyor'" (click)="wsBaglan.emit()">
              Dinlemeyi Baslat
            </button>
          } @else {
            <button class="ko-btn ko-btn-kopar" (click)="wsKopar.emit()">Dinlemeyi Durdur</button>
          }
        </div>

        @if (wsHata) { <div class="ko-hata">{{ wsHata }}</div> }

        <div class="ko-bilgi">
          Mevcut FikoYT Socket.IO baglantisi uzerinden kart okuyucu olaylarini dinler.<br>
          NodeMCU kart okuyucu ayni sunucuya <code>FikoYT.sistem.io.cihaz.guncellendi</code> olayi gonderir.<br>
          Ayri baglanti gerekmez - sistem zaten sunucuya bagli.
        </div>
      </div>
      }

      <!-- ===== MONITOR SEKMESI ===== -->
      @if (aktifTab === 2) {
      <div class="ko-tab-panel ko-fade-in">
        <div class="ko-alan">
          <div class="ko-alan-etiket">
            Monitor
            <span class="ko-log-sayac">{{ seriLog.length }} satir</span>
            @if (seriLog.length > 0) {
              <span class="ko-log-temizle" (click)="logTemizle.emit()">Temizle</span>
            }
          </div>
          <div class="ko-monitor">
            @for (satir of seriLog; track $index) {
            <div class="ko-monitor-satir" [class.uid-satir]="satir.uidBulundu">
              <span class="ko-monitor-zaman">{{ satir.zaman }}</span>
              <span class="ko-monitor-veri" [class.uid]="satir.uidBulundu">{{ satir.veri }}</span>
              @if (satir.uidBulundu) {
                <span class="ko-monitor-uid">UID: {{ satir.uid }}</span>
              }
            </div>
            }
            @if (seriLog.length === 0) {
              <div class="ko-monitor-bos">Veri bekleniyor...</div>
            }
          </div>
          <!-- Komut gonderme -->
          <div class="ko-komut-row">
            <input class="ko-komut-input" type="text"
              [(ngModel)]="komutMetni"
              placeholder="{{ baglantiModu === 'websocket' ? 'Socket.IO modunda komut gonderilemez' : 'Komut yaz... (Enter ile gonder)' }}"
              [disabled]="!aktifBaglanti || baglantiModu === 'websocket'"
              (keydown.enter)="komutGonderildi.emit(komutMetni); komutMetni = ''" />
            <button class="ko-komut-btn" [disabled]="!aktifBaglanti || !komutMetni.trim() || baglantiModu === 'websocket'" (click)="komutGonderildi.emit(komutMetni); komutMetni = ''">Gonder</button>
          </div>
        </div>
      </div>
      }

    </div>
  </div>
</div>
}
